module.exports = __webpack_public_path__ + "static/media/google-chrome-icon.5518c035.png";